import style from '../style';

const boxShadow = style({
  prop: 'boxShadow',
  themeKey: 'shadows',
});

export default boxShadow;
